import { Form, InputNumber } from '@arco-design/web-react'
import JsonField, { validateJson } from '../JsonField'
import InstantSwitch from '../InstantSwitch'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'claude.model_headers_settings',
  'claude.default_max_tokens',
  'claude.thinking_adapter_enabled',
  'claude.thinking_adapter_budget_tokens_percentage',
]

export default function ClaudeModelSection({ options }: { options: OptionsAPI }) {
  const { get, getNumber, patch } = options

  const validate = () => {
    for (const k of ['claude.model_headers_settings', 'claude.default_max_tokens']) {
      const msg = validateJson(get(k))
      if (msg) return `${k}: ${msg}`
    }
    return null
  }

  return (
    <SettingSectionCard title="Claude 模型" keys={KEYS} options={options} validate={validate}>
      <Form layout="vertical">
        <Form.Item label="Model Headers Settings JSON">
          <JsonField
            value={get('claude.model_headers_settings')}
            onChange={(v) => patch({ 'claude.model_headers_settings': v })}
            rows={4}
          />
        </Form.Item>
        <Form.Item label="Default Max Tokens JSON">
          <JsonField
            value={get('claude.default_max_tokens')}
            onChange={(v) => patch({ 'claude.default_max_tokens': v })}
            rows={4}
          />
        </Form.Item>
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="Thinking Adapter">
            <InstantSwitch options={options} optionKey="claude.thinking_adapter_enabled" defaultChecked />
          </Form.Item>
          <Form.Item label="Thinking Budget 比例">
            <InputNumber
              style={{ width: 240 }}
              min={0}
              max={1}
              step={0.1}
              value={getNumber('claude.thinking_adapter_budget_tokens_percentage', 0.8)}
              onChange={(v) => patch({ 'claude.thinking_adapter_budget_tokens_percentage': v ?? 0.8 })}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
